<template>
  <div class="search">
        <audio src="" ref="audio" loop></audio>

    <div class="big_cont">
      <header>
        <div class="inner">
          <div class="back">
            <img
              width="30"
              height="30"
              src="../../assets/go_back.png"
              alt=""
              @click="toHome"
            />
            <div>搜索</div>
          </div>
          <div class="header">
            <div class="header_center">
              <div class="header_box">
                <!-- 搜索栏 -->
                <div class="box_seach">
                  <el-select v-model="param.type" size="small">
                    <el-option value="0" label="全部" />
                    <el-option value="1" label="模板" />
                    <el-option value="2" label="字体" />
                    <el-option value="3" label="动画" />
                    <el-option value="4" label="视频" />
                    <el-option value="5" label="音频" />
                    <el-option value="6" label="3D模型" />
                    <el-option value="7" label="音效" />
                  </el-select>
                  <input
                    type="text"
                    v-model="param.keyword"
                    @keyup.enter="searchClick"
                    placeholder="模板/字体/动画/视频/音频/3D模型/音效"
                  />
                  <div class="button" @click="searchClick">搜索</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- 内容部分 -->
      <div class="cont">
        <div class="type">
          <div
            class="item"
            v-for="(item, index) in typeList"
            :key="index"
            @click="changeType(index)"
          >
            <span :class="[item.selected === true ? 'active' : 'un_active']">{{
              item.name
            }}</span>
          </div>
        </div>
        <div class="list" v-if="lists.length > 0">
          <div class="list-row" v-for="item in 3" :key="item">
            <div
              class="list-item"
              v-for="(items, indexs) in lists[item - 1]"
              :key="indexs"
            >
              <!-- 音频 -->
              <div
                v-show="items.type === 5"
                class="box box5"
                @click="showDetail(items.type, items.product_id)"
              >
                <img :class="{imgRotate:items.play}" src="../../assets/audioPlay.png" @click.stop="playMusic(items)" />
                <div class="name">{{ items.title }}</div>
              </div>
              <!-- 音效 -->
              <div
                v-show="items.type === 7"
                class="box box5"
                @click="showDetail(items.type, items.product_id)"
              >
                <img :class="{imgRotate:items.play}" src="../../assets/audioPlay.png" @click.stop="playMusic(items)" />
                <div class="name">{{ items.title }}</div>
              </div>

              <div
                v-show="items.type === 4"
                class="box box4"
                @click="showDetail(items.type, items.product_id)"
              >
                <div class="pic">
                  <el-image :src="items.image"></el-image>
                </div>
                <div class="name">
                  {{ items.title }}
                </div>
              </div>

              <div
                v-show="items.type === 3"
                class="box box3"
                @click="showDetail(items.type, items.product_id)"
              >
                <div class="pic">
                  <el-image :src="items.image"></el-image>
                </div>
                <div class="name">
                  {{ items.title }}
                </div>
              </div>

              <div
                v-show="items.type === 6"
                class="box box6"
                @click="showDetail(items.type, items.product_id)"
              >
                <div class="pic">
                  <el-image :src="items.image"></el-image>
                </div>
                <div class="name">
                  {{ items.title }}
                </div>
              </div>

              <div
                v-show="items.type === 2"
                class="box box2"
                @click="showDetail(items.type, items.product_id)"
              >
                <div class="pic">
                  <el-image :src="items.image"></el-image>
                </div>
                <div class="name">{{ items.title }}</div>
              </div>

              <div
                v-show="items.type === 1"
                class="box box1"
                @click="showDetail(items.type, items.product_id)"
              >
                <div class="pic">
                  <el-image :src="items.image"></el-image>
                </div>
                <div class="name">{{ items.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty_style">
          <el-image :src="require('../../assets/empty.png')"></el-image
          ><span>暂无数据</span>
        </div>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[12, 24, 36, 48]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import {
  getList,
  getCategoryByType,
  searchProduct,
  getCategory,
  getDetail,
  toggleCollect,
  buyResource
} from '../../api/index'

export default {
  data () {
    return {
      imgSrc: require('../../assets/audio.png'),
      type: '0',
      page: 1,
      pageSize: 12,
      total: 0,
      // 类型数据
      typeList: [
        {
          name: '全部',
          type: '0',
          selected: true
        },
        {
          name: '模板',
          type: '1',
          selected: false
        },

        {
          name: '字体',
          type: '2',
          selected: false
        },
        {
          name: '动画',
          type: '3',
          selected: false
        },
        {
          name: '视频',
          type: '4',
          selected: false
        },
        {
          name: '音频',
          type: '5',
          selected: false
        },
        {
          name: '3D模型',
          type: '6',
          selected: false
        },
        {
          name: '音效',
          type: '7',
          selected: false
        }
      ],
      // 图片数据
      lists: [[], [], []],
      hotSeach: [
        {
          name: '热门'
        },
        {
          name: '办公'
        },
        {
          name: '自然'
        },
        {
          name: '娱乐'
        }
      ], // 热门搜索数据
      down: {
        dialog: false
      },
      // 详情弹窗
      detailDialog: {
        product_id: '',
        dialog: false
      },
      param: {
        keyword: '',
        type: ''
      }
    }
  },

  created () {
    this.param.keyword = this.$route.query.keyword
    this.param.type = this.$route.query.type
    // this.search()
    this.changeType(this.param.type ? this.param.type : '0')
  },
  methods: {
    playMusic (items) {
      this.lists.forEach(item1 => {
        item1.forEach(item => {
          if (item.product_id == items.product_id) {
            item.play = !item.play
            this.$refs.audio.src = items.src
            item.play ? this.$refs.audio.play() : this.$refs.audio.pause()
          } else {
            item.play = false
          }
        })
      })
    },
    // 搜索
    search (select) {
      this.$nextTick(() => { this.$refs.audio.pause() })
      const data = {
        keyword: this.param.keyword,
        type: this.param.type === '0' ? '' : this.param.type,
        offset: (this.page - 1) * this.pageSize,
        length: this.pageSize
      }
      searchProduct(data, (res) => {
        this.lists = [[], [], []]
        const temp = res.result.data
        this.total = res.result.total
        temp.forEach((item, index) => {
          item.src = this.$imageUrl + JSON.parse(item.desc).image[0]
          item.image = this.$imageUrl + item.image
          this.lists[index % 3].push(item)
        })
        this.lists.forEach(item1 => {
          item1.forEach(item2 => {
            this.$set(item2, 'play', false)
          })
        })
        console.log(this.lists)
      })
    },
    // 本页面搜索点击
    searchClick () {
      this.page = 1
      this.search()
    },
    // 点击热门搜索
    hotClick (val) {
      this.keyword = val
      this.param.keyword = this.keyword
      this.search()
    },

    // 点击显示详情
    showDetail (type, id) {
      this.$router.push({
        path: '/product_detail',
        query: { type: type, product_id: id }
      })
    },
    // 前往首页
    toHome () {
      this.$router.push({ path: '/' })
    },
    // 选择类型
    changeType (index) {
      this.typeList.forEach((item, i) => {
        item.selected = false
        if (Number(index) === i) this.typeList[index].selected = true
      })
      // this.type = this.typeList[index].type
      // this.param.keyword = ''
      this.param.type = this.typeList[index].type
      if (this.page > 1) this.page = 1
      this.search()
    },
    // 分页
    handleSizeChange (e) {
      this.pageSize = e
      this.search()
    },
    handleCurrentChange (e) {
      this.page = e
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  width: 100%;
  min-height: 100vh;
  background-color: #eee;
  .big_cont {
    width: 100%;
  }
  header {
    width: 100%;
    height: 140px;
    background-color: #fff;
    .inner {
      width: 90%;
      min-width: 864px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .back {
      display: flex;
      align-items: center;
      img {
        cursor: pointer;
      }
      div {
        margin-left: 20px;
        font-size: 18px;
        font-weight: 700;
      }
    }

    .header {
      height: 140px;
      display: flex;
      .header_center {
        flex: 1;
        height: 140px;
        display: flex;
        align-items: center;
        position: relative;
        .header_box {
          width: 600px;
          box-sizing: border-box;
          .box_seach {
            width: 520px;
            height: 41px;
            background-color: #fff;
            border-radius: 6px;
            border: 2px solid #0493fe;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            input {
              flex: 1;
              height: 30px;
              font-size: 14px;
              border: none;
              outline: none;
              color: #666;
            }
            .button {
              width: 70px;
              height: 38px;
              line-height: 38px;
              margin-right: -1px;
              text-align: center;
              background-color: #0493fe;
              color: #ffffff;
              cursor: pointer;
              user-select: none;
              font-size: 15px;
              z-index: 999;
            }
          }
        }
      }
    }
  }
  .cont {
    margin: 20px auto 0px;
    padding-bottom: 20px;
    width: 80%;
    .type {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      background-color: #fff;
      .item {
        margin: 0 28px;
      }
      .item:hover span {
        color: #0493fe;
        cursor: pointer;
      }
      .active {
        color: #0493fe;
      }
      .un_active {
        color: #666;
      }
    }
    .recommend {
      margin-top: 20px;
      display: flex;
      align-items: flex-end;
      span {
        margin-right: 20px;
        color: #999;
      }
    }
    .list {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      // justify-content: flex-start;
      // flex-wrap: wrap;
      .list-row {
        display: flex;
        flex-direction: column;
        width: calc(100% / 3);
      }
      .list-item {
        // width: 33%;
        .name {
          padding: 5px 10px;
          font-size: 18px;
          color: #666;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .box1 {
        position: relative;
        margin-bottom: 20px;
        padding: 5px;
        margin-right: 20px;

        background-color: #fff;
        .pic {
          height: 400px;
          overflow: hidden;
          .el-image {
            width: 100%;
          }
        }
      }
      .box2 {
        margin-right: 20px;
        margin-bottom: 20px;
        border-radius: 5px;
        padding: 5px;
        background-color: #fff;
        .pic {
          .el-image {
            width: 100%;
          }
        }

        .status {
          width: 15px;
          height: 15px;
          margin-right: 5px;
          text-align: center;
          line-height: 15px;
          font-size: 10px;
          color: #13acf1;
          border: 1px solid #999;
          border-radius: 50%;
        }
      }
      .box3 {
        margin-right: 20px;
        margin-bottom: 20px;
        // width: 280px;
        background-color: #fff;
        .pic {
          .el-image {
            width: 100%;
          }
        }
      }
      .box4 {
        margin-bottom: 20px;
        margin-right: 20px;
        background-color: #fff;
        .pic {
          .el-image {
            width: 100%;
          }
        }
      }
      .box5 {
        overflow: hidden;
        position: relative;
        margin-bottom: 20px;
        padding: 10px;
        margin-right: 20px;
        background-color: #fff;
        .format {
          margin: 20px 0;
          font-size: 12px;
          color: #999;
        }
        img {
          width: 100%;
        }
        .name{
          position: relative;
          z-index: 6;
        }
      }
      .box6 {
        margin-right: 20px;
        margin-bottom: 20px;
        background-color: #fff;
        .pic {
          .el-image {
            width: 100%;
          }
        }
      }
      .box:hover {
        cursor: pointer;
        box-shadow: 0 0 9px 3px #ccc;
      }
      .msg1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 250px;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        font-size: 12px;
        :first-child {
          color: #ccc;
          font-size: 20px;
        }
        :last-child {
          width: 45px;
          height: 16px;
          font-size: 12px;
          text-align: center;
          line-height: 15.5px;
          border-radius: 10px;
          color: #fff;
          background-color: #f2ba1a;
        }
      }
      .msg2 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 240px;
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        font-size: 12px;
        line-height: 40px;
        color: #fff;
      }
    }
    .empty_style {
      height: 500px;
      color: #999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-image {
        margin-bottom: 20px;
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
    }
  }
  .detail_pic {
    width: 420px;
    height: 320px;
    .el-image {
      width: 100%;
      height: 300px;
    }
  }
  .detail_msg {
    margin-left: 20px;
    width: 240px;
    .title {
      font-size: 18px;
      color: #333;
    }
    .base {
      margin-top: 20px;
      font-size: 18px;
      color: #000;
    }
    .popular {
      margin: 20px 0 10px 0;
      font-size: 12px;
      color: #999;
      span {
        margin: 0 10px;
      }
      .icon:hover {
        cursor: pointer;
        color: red;
      }
      .is_collect {
        color: red;
      }
      .no_collect {
        color: #999;
      }
    }
    .popular2 {
      margin: 10px 0;
      font-size: 12px;
      color: #999;
    }

    .character {
      margin-bottom: 20px;
      font-size: 12px;
      color: #666;
      span {
        margin: 0 5px;
      }
    }
    .other {
      margin: 15px 0;
      :first-child {
        color: #999;
        font-size: 12px;
        margin-right: 10px;
      }
      :last-child {
        color: #666;
        font-size: 14px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
<style lang="scss">
.box_seach {
  .el-select {
    width: 100px;
    .el-input__inner {
      border: none;
    }
  }
}
.imgRotate {
            animation: rotate 2s ease-in-out infinite;
          }
          @keyframes rotate {
            100%{
              transform: rotate(360deg);
            }
          }
</style>
